import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Pandetails(state = initialState, action) {
  switch (action.type) {
    case userConstants.PAN_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.PAN_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.PAN_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}